import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import CardDeadline from '@/components/CardDeadline/index.vue'
import Loader from '@/components/Loader/index.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'

library.add(faPlusCircle)

@Component({
	components: { CardDeadline, Loader },
})
export default class CardDay extends Vue {
	@Prop() readonly day
	@Prop() readonly deadlines
	@Prop() readonly notBusinessDay
	@Prop() readonly height

	wrapperInnerDeadlineContentMaxHeight: number | null = null

	@Watch('height')
	async onStateChange(height) {
		const newHeight = height - 24 - 20 - 3
		if (newHeight >= 0) {
			this.wrapperInnerDeadlineContentMaxHeight = newHeight
		}
	}
}
